import { PButton, PInlineNotification } from "@porsche-design-system/components-react"
import { FormattedMessage, useIntl } from "react-intl"
import { formMessages } from "src/common/form.messages"
import type {
	ColorPickerFieldProps,
	ColorRadioButtonGroupProps,
	InputFieldProps,
	RadioGroupFieldProps,
} from "src/components"
import {
	ButtonGroup,
	FormLayout,
	FormLayoutGroup,
	ColorPickerField,
	ColorRadioGroupField,
	InputField,
	RadioGroupField,
} from "src/components"
import { messages } from "../useCustomExteriorColor"

export interface CustomExteriorColorProps {
	hasSubmitFailed: boolean
	hexCode: ColorPickerFieldProps
	isSubmitting: boolean
	name: InputFieldProps[]
	setHasSubmitFailed: (value: boolean) => void
	showCatalogExteriorColorContainer: () => void
	tag: ColorRadioButtonGroupProps
	type: RadioGroupFieldProps
}

export const CustomExteriorColor = ({
	hasSubmitFailed,
	hexCode,
	isSubmitting,
	name,
	setHasSubmitFailed,
	showCatalogExteriorColorContainer,
	tag,
	type,
}: CustomExteriorColorProps) => {
	const { formatMessage } = useIntl()
	return (
		<FormLayoutGroup>
			<FormLayout>
				{name.map((props, index) => (
					<InputField key={index} {...props} />
				))}
			</FormLayout>
			<ColorRadioGroupField {...tag} />
			<RadioGroupField {...type} />
			<ColorPickerField {...hexCode} />
			{hasSubmitFailed && (
				<PInlineNotification
					state="error"
					description={formatMessage(formMessages.errorGeneral)}
					onDismiss={() => setHasSubmitFailed(false)}
				/>
			)}
			<ButtonGroup withoutMarginTop>
				<PButton type="submit" loading={isSubmitting}>
					<FormattedMessage {...formMessages.save} />
				</PButton>
				<PButton type="button" variant="secondary" onClick={showCatalogExteriorColorContainer}>
					<FormattedMessage {...messages.selectCatalogExteriorColor} />
				</PButton>
			</ButtonGroup>
		</FormLayoutGroup>
	)
}
